import React, { MouseEvent } from "react"
import { Link, LinkProps } from "react-router-dom"
import clsx from "clsx"

interface LuiButtonProps extends PlanButtonProps {
  to?: LinkProps["to"]
  href?: string
  openInNewTab?: boolean
  level?: "text" | "primary" | "secondary" | "tertiary"
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"]
  size?: "small" | "med" | "large"
}

interface PlanButtonProps {
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"]
  disabled?: boolean
  style?: React.CSSProperties
  onClick?: (e: MouseEvent) => void
  name?: string
  title?: string
  "data-testid"?: string
  className?: string
}

const PlainButton: React.FC<PlanButtonProps & { level: string; size: string }> = (props) => {
  return (
    <button
      type={props.type}
      title={props.title}
      disabled={props.disabled}
      name={props.name}
      onClick={props.onClick}
      className={clsx("lui-button", `lui-button-${props.level}`, `lui-button-${props.size}`, props.className)}
      data-testid={props["data-testid"]}
      style={props.style}
    >
      {props.children}
    </button>
  )
}

export const LuiButton: React.FC<LuiButtonProps> = (props) => {
  const _level = props.level ? props.level : "primary"
  const size = props.size ? props.size : "med"

  if (props.href) {
    let aProps: any = {
      href: props.href,
      className: clsx("lui-button", `lui-button-${props.level}`, `lui-button-${props.size}`, props.className),
    }

    if (props.openInNewTab) {
      aProps.target = "_blank"
      aProps.rel = "noopener noreferrer"
    }

    return <a {...aProps}>{props.children}</a>
  }

  const plainButton = (
    <PlainButton
      type={props.type}
      title={props.title}
      disabled={props.disabled}
      name={props.name}
      onClick={props.onClick}
      level={_level}
      size={size}
      data-testid={props["data-testid"]}
      style={props.style}
      className={props.className}
    >
      {props.children}
    </PlainButton>
  )

  if (props.to) {
    return (
      <Link to={props.to} style={{ borderBottom: "none" }}>
        {plainButton}
      </Link>
    )
  }

  return <>{plainButton}</>
}

export const LuiButtonGroup: React.FC<{ children: any }> = (props) => {
  return (
    <div className="lui-button-group" data-testid={"button-group"}>
      {props.children.map((child: React.FC) => {
        return <div className={"lui-button-wrapper"}>{child}</div>
      })}
    </div>
  )
}
